import CryptoJS from 'crypto-js'

const AES_KEY = CryptoJS.enc.Utf8.parse('x7d9Fk3mQ8v2Lp6Z')

/** 加密：任意对象 → Base64 字符串 */
export function encrypt (data) {
  return CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(JSON.stringify(data)),
    AES_KEY,
    { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
  ).toString()
}

/** 解密：Base64 字符串 → 原始对象 */
export function decrypt (encryptedStr) {
  return JSON.parse(
    CryptoJS.AES.decrypt(encryptedStr, AES_KEY, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8)
  )
}

/** 判断是否为加密字符串 */
export function isEncrypted (str) {
  if (typeof str !== 'string' || str.length < 10) return false
  try {
    decrypt(str)
    return true
  } catch (e) {
    return false
  }
}
